module.exports = __webpack_public_path__ + "media/emptyVoice.5c4fb0db.mp3";